import React from 'react';
import Icon from '../../../components/AppIcon';

const TextLessonView = ({ lesson }) => {
  return (
    <div className="bg-white/70 backdrop-blur-xl rounded-2xl border border-white/40 shadow-sm p-6 sm:p-10">
      <div className="flex items-center gap-2 mb-6 pb-5 border-b border-border/60">
        <div className="w-8 h-8 rounded-lg bg-accent/10 flex items-center justify-center">
          <Icon name="FileText" size={15} className="text-accent" />
        </div>
        <span className="text-xs font-semibold text-muted-foreground uppercase tracking-widest">Reading</span>
      </div>
      {lesson?.content ? (
        <div className="prose prose-sm sm:prose-base max-w-none text-foreground whitespace-pre-wrap leading-relaxed sm:leading-8">
          {lesson.content}
        </div>
      ) : (
        <div className="text-center py-12">
          <Icon name="FileQuestion" size={24} className="text-muted-foreground mx-auto mb-3" />
          <p className="text-muted-foreground text-sm">No content has been added to this lesson yet.</p>
        </div>
      )}
    </div>
  );
};

export default TextLessonView;